<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar />
    
    <TheHeader />

    <div
      class="c-wrapper"
      :class="{ 'sidebar-open': $store.state.sidebarShow }"
    >
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "../TheFooter";
import { mapActions } from "vuex";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  mounted() {
    this.loadUserProfile();
  },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() {
      try {
        await this.getProfile();
      } catch (err) {
        console.error("Load profile error:", err);
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Base Wrapper Style */
.c-wrapper {
  transition: margin-left 0.3s ease;
  margin-left: 0; /* ค่าเริ่มต้น (Mobile) เป็น 0 */
  min-height: 100vh;
}

/* ดันเนื้อหาลงมาใต้ Header */
.c-body {
  padding-top: 60px; /* เท่ากับความสูง Header */
}

/* =========================================
   🔥 แก้ไขตรงนี้: สั่งให้ดันเนื้อหา เฉพาะในคอมพิวเตอร์ 🔥
   ========================================= */
@media (min-width: 992px) {
  /* ทำงานเฉพาะหน้าจอที่กว้างกว่า 992px (Desktop/Tablet แนวนอน) */
  .sidebar-open {
    margin-left: 250px; /* ดันเนื้อหาหลบ Sidebar */
  }
  
  .sidebar-minimized {
    margin-left: 80px; /* กรณีพับ Sidebar */
  }
}
</style>